import { __makeTemplateObject } from '../../node_modules/tslib/tslib.es6.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { media, Text, IconButton, CloseIcon } from '@elseu/sdu-titan';
import styled, { css } from 'styled-components';
import { getSectionSpacing } from '../../sections/Section/Section.js';
import { Link } from '../Link/Link.js';
import { NavigationButtons } from './NavigationButtons.js';
import { NavigationLogo } from './NavigationLogo.js';

var StyledNavigationMain = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    border-bottom: 1px solid ", ";\n\n    display: none;\n\n    ", "\n  "], ["\n    border-bottom: 1px solid ", ";\n\n    display: none;\n\n    ", "\n  "])), theme.designTokens.colors.grey30, media.greaterThan('s')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      display: block;\n    "], ["\n      display: block;\n    "]))));
});
var MainContent = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: relative;\n    width: 100%;\n    display: flex;\n    height: 92px;\n    gap: ", ";\n    justify-content: space-between;\n\n    ", "\n  "], ["\n    position: relative;\n    width: 100%;\n    display: flex;\n    height: 92px;\n    gap: ", ";\n    justify-content: space-between;\n\n    ", "\n  "])), theme.spacing[8], getSectionSpacing({
    theme: theme,
    xPadding: [8, 8, 12, 24],
    yPadding: 6
  }));
});
var Main = styled.ul(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    display: flex;\n    align-self: center;\n    gap: ", ";\n  "], ["\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    display: flex;\n    align-self: center;\n    gap: ", ";\n  "])), theme.spacing[6]);
});
var MainItem = styled(Text)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var isActive = _a.isActive;
  return css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    > a {\n      font-weight: 700;\n      ", "\n\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n  "], ["\n    > a {\n      font-weight: 700;\n      ", "\n\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n  "])), isActive && 'text-decoration: underline;');
});
var StyledIconButton = styled(IconButton)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  padding: 0;\n"], ["\n  padding: 0;\n"])));
/**
 * The NavigationMain component
 */
var NavigationMain = function (_a) {
  var logo = _a.logo,
    main = _a.main,
    isSearchActive = _a.isSearchActive,
    setOpenMenuIndex = _a.setOpenMenuIndex,
    showColumnIndex = _a.showColumnIndex,
    openMenuIndex = _a.openMenuIndex,
    setIsSearchActive = _a.setIsSearchActive,
    search = _a.search;
  return jsx(StyledNavigationMain, {
    children: jsxs(MainContent, {
      children: [jsx(NavigationLogo, {
        logo: logo
      }), !isSearchActive ? jsxs(Fragment, {
        children: [main && jsx(Main, {
          children: main.map(function (_a, index) {
            var to = _a.to,
              title = _a.title,
              children = _a.children;
            return !children ? jsx(MainItem, {
              as: "li",
              type: "labelLargeBold",
              isActive: false,
              children: jsx(Link, {
                to: to,
                children: title
              })
            }, "link-".concat(index)) : jsx(MainItem, {
              as: "li",
              type: "labelLargeBold",
              onFocus: function () {
                return setOpenMenuIndex(index);
              },
              onBlur: function () {
                return setOpenMenuIndex(null);
              },
              onMouseEnter: function () {
                return showColumnIndex(index);
              },
              isActive: openMenuIndex === index,
              children: jsx(Link, {
                to: to,
                children: title
              })
            }, "navigation-group-".concat(index));
          })
        }), jsx(NavigationButtons, {
          setIsSearchActive: setIsSearchActive
        })]
      }) : jsxs(Fragment, {
        children: [search, jsx(StyledIconButton, {
          label: "Zoeken sluiten",
          icon: jsx(CloseIcon, {
            fontSize: 24
          }),
          onClick: function () {
            return setIsSearchActive(false);
          }
        })]
      })]
    })
  });
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;

export { NavigationMain };
//# sourceMappingURL=NavigationMain.js.map
